import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';
import { AppComponent } from './app.component';
import { FileRecordComponent } from './records/file-record.component';
import { HomeComponent } from './home/home.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { UploaderComponent } from './uploader/uploader.component';
import { DataTableComponent } from './data-table/data-table.component';
import { CsvConverterService } from './converter/csv-converter.service';
import { FileRecordService } from './records/file-record.service';
import { HmlValidationService } from './validation/hml-validation.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ModalComponent } from './modal/modal.component';
import { ThrobberComponent } from './records/throbber.component';
import { ValidationErrorsComponent } from './data-table/validation-errors.component';
import {HTTP_INTERCEPTORS, HttpClientJsonpModule, HttpClientModule} from '@angular/common/http';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {MatIconModule} from '@angular/material/icon';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AnnouncementsComponent} from './announcements/announcements.component';
import {NgxNewstickerAlbeModule} from 'ngx-newsticker-albe';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {AuthAppModule} from './auth/auth.app.module';
import {AuthInterceptor, OidcSecurityService} from 'angular-auth-oidc-client';
import {GuestFileValidationComponent} from "./guest-file-validation/guest-file-validation.component";

@NgModule({
  imports: [
    AuthAppModule,
    BrowserModule,
    CommonModule,
    FileUploadModule,
    NgbModule,
    FormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    BrowserAnimationsModule,
    MatIconModule,
    ModalModule.forRoot(),
    NgxNewstickerAlbeModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    NgbModule
  ],
  declarations: [
    AnnouncementsComponent,
    AppComponent,
    FileRecordComponent,
    GuestFileValidationComponent,
    HomeComponent,
    NavbarComponent,
    FooterComponent,
    UploaderComponent,
    DataTableComponent,
    ModalComponent,
    ThrobberComponent,
    ValidationErrorsComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    CsvConverterService,
    FileRecordService,
    HmlValidationService,
    {
      provide: HTTP_INTERCEPTORS, useClass:AuthInterceptor, multi: true
    },
    OidcSecurityService
  ],
  bootstrap: [ AppComponent ]
})
export default class AppModule {
}
